import { render, staticRenderFns } from "./UpdatePasswordPage.vue?vue&type=template&id=1a044040&scoped=true"
import script from "./UpdatePasswordPage.vue?vue&type=script&lang=js"
export * from "./UpdatePasswordPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a044040",
  null
  
)

export default component.exports